export var Constants = {
  SORT: {
    SELECTOR: "js-select-sorting",
    INFORMATION_MODAL: {
      OPEN_BUTTON: "js-sort-information-modal-open-button",
      CLOSE_BUTTON: "js-sort-information-modal-close-button",
      CONTENT: "js-sort-information-modal"
    }
  },
  FILTER_FORM_SELECTOR: {
    FORM: "js-form-filters",
    RESET: "js-reset-filters"
  },
  RANGE_FILTERS: {
    INPUT_SELECTOR: "js-range",
    SUBMIT_SELECTOR: "js-rangeApply",
    RESET_SELECTOR: "js-rangeReset"
  },
  REVIEW_FILTERS: {
    RESET_SELECTOR: "js-reviewReset"
  },
  FILTERS_TYPES: {
    STANDARD: "standard",
    RANGE: "range",
    TOGGLE: "toggle",
    IMAGE: "image",
    COLOR: "color",
    VENDOR: "vendor",
    REVIEW: "review",
    PEDAGOGICAL: "pedagogical"
  },
  SELECTED_FILTERS: {
    DELETE_SELECTOR: "js-delete-filter > button",
    RESET_SELECTOR: "js-reset-selected-filters"
  },
  FILTERS_LAYER: {
    CONTENT: "js-filters-layer-content",
    OPEN_BUTTON: "js-filters-layer-open-button",
    CLOSE_BUTTON: "js-filters-layer-close-button"
  },
  HIDDEN_CLASS: "kl-hidden",
  TRACKING_INFOS: {
    UNIVERSE: window.tc_vars.page_cat1_label ? window.tc_vars.page_cat1_label : "",
    SUB_UNIVERSE: window.tc_vars.page_cat2_label ? window.tc_vars.page_cat2_label : "",
    FAMILY: window.tc_vars.page_cat3_label ? window.tc_vars.page_cat3_label : "",
    SUB_FAMILY: window.tc_vars.page_cat4_label ? window.tc_vars.page_cat4_label : "",
    CATEGORY_CHECKED: "facette",
    CATEGORY_UNCHECKED: "désélection facette",
    SORTING: "utilisation tri"
  },
  FILTERS_TOOLTIP_MORE_INFO: {
    SELECTOR: "js-tooltip-"
  }
};